import type { GENERATED } from './generated'

// `typeof GENERATED[Slug]` without importing the value: `generated/index.ts`
// eagerly imports every set's JSON (~1.2MB across all 52), fine for the
// server (sitemap, static params, the OG route) but never safe to reach a
// client bundle. `import type` is erased at compile time, so this file can
// describe the shape without paying for it.
type Slug = keyof typeof GENERATED
export type Generated = (typeof GENERATED)[Slug]

// One set's baked build data (steps, parts, notes), as its own network
// chunk. The template-literal `import()` is a webpack/Turbopack "context
// import": each `data/generated/<slug>.json` becomes its own lazily-loaded
// module, so opening one booklet fetches one set's data, not the catalog's.
export function loadGeneratedSet(slug: string): Promise<Generated> {
  return import(`./generated/${slug}.json`).then((m) => m.default as Generated)
}
